import React, {useEffect, useMemo, useRef, useState} from 'react';

import {Button, DataGrid, FileUploader, Gallery, ScrollView} from "devextreme-react";
import {Button as ButtonGrid, Column, DataGridTypes, GroupPanel, Paging} from 'devextreme-react/data-grid';
import {Popup} from "devextreme-react/popup";
import IFichierJoint from "../../models/IFichierJoint";

interface IPopupProps {
    close: () => void,
    fichiers: IFichierJoint[],
    setFiles: (fichier: IFichierJoint) => void
}

const DiffCell = (cellData: any) => {
    return (
        <div>
            {cellData.row.data.type &&
                <div className={`type ${cellData.row.data.type}`}></div>
            }
        </div>
    );
};

const onFilesUploaded = (file: any) => {
    console.log(file)
}

const PopupFichierJoint = ({close, fichiers, setFiles}: IPopupProps) => {
    const inputFilesRef = useRef<HTMLInputElement>(null)

    return <Popup
        visible={true}
        onHiding={close}
        dragEnabled={true}
        resizeEnabled={true}
        hideOnOutsideClick={true}
        showCloseButton={true}
        showTitle={true}
        dragOutsideBoundary={true}
        title="Liste des fichiers joints"
        container=".dx-viewport"
        width={"550px"}
        height={"350px"}
    >
        <div style={{display: "flex", flexDirection: "column", gap: "1rem", height: "100%", padding: "1rem"}}>
            <input ref={inputFilesRef} type={"file"} style={{display: "none"}} accept="*" multiple onChange={async (e) => {
                await [...e.target.files || []].reduce(async (promise, file) => {
                    await promise;
                    const fr = new FileReader();

                    fr.readAsDataURL(file);
                    fr.onload = () => {
                        const url = ""//file. as string;
                        if (fr.result) {
                            setFiles({name: file.name, isFromBackEnd: false, type: file.type, data: fr.result});
                        }
                    };
                }, Promise.resolve());
            }}/>
            <div>
                <Button onClick={() => inputFilesRef.current?.click()} text={"Sélectionnez un ou plusieurs fichiers"}/>
            </div>
            <div style={{flex: 1, border: "1px solid rgba(0,0,0,0.10)"}}>
            <DataGrid
                showBorders={true}
                dataSource={fichiers}
                allowColumnReordering={true}
                editing={{
                    allowDeleting: true
                }}
                keyExpr="id"
            >
                <Column allowEditing={false} dataField="type"
                        cellRender={DiffCell}
                        dataType="string" width={25} caption=''/>
                <Column dataField="name" dataType="string" caption={"Description"}/>
            </DataGrid>
            </div>
            <div style={{alignSelf: "end"}}>
                <Button style={{width: "6rem", alignItems: "center"}} onClick={() => close()}>Ok</Button>
            </div>
        </div>
    </Popup>
}

export default PopupFichierJoint;